import { makeStyles } from 'tss-react/mui';
import { get } from 'lodash';
import { Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';

const useStyles = makeStyles()((theme) => ({
  cellStyle: {
    maxWidth: '20px',
    overflowWrap: 'break-word',
  },
}));

function SimpleTable({ columns, rows }) {
  const { classes } = useStyles();

  return (
    <Table>
      <TableHead>
        <TableRow>
          {columns.map(({ label, width }) => (
            <TableCell style={{ minWidth: width }} key={`head-${label}`}>{label}</TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {rows.map((row, i) => (
          <TableRow key={`row-${i}`}>
            {columns.map(({ dataKey, renderer }, colIndex) => {
              const data = get(row, dataKey);

              if (Array.isArray(data)) {
                return <TableCell className={classes.cellStyle} key={`cell-${i}-${colIndex}`}>{data.join(',')}</TableCell>;
              }

              if (renderer) {
                return <TableCell className={classes.cellStyle} key={`cell-${i}-${colIndex}`}>{renderer(data)}</TableCell>;
              }

              if (typeof data === 'boolean') {
                return <TableCell className={classes.cellStyle} key={`cell-${i}-${colIndex}`}>{data?.toString()}</TableCell>;
              }

              return <TableCell className={classes.cellStyle} key={`cell-${i}-${colIndex}`}>{data}</TableCell>;
            })}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}

export default SimpleTable;
